import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../constants";
import Icon from "../../components/icon/Icon";
import styles from "./GeneralInformation2.module.css";

const GeneralInformation2 = ({ name }) => {
  const [importantNotes, setImportantNotes] = useState({});
  const [notes, setNotes] = useState([]);
  const [helpfulLinks, setHelpfulLinks] = useState([]);

  const links = helpfulLinks.filter((usefulLink) => usefulLink.link?.length > 0);
  const emails = helpfulLinks.filter((usefulLink) => usefulLink.email?.length > 0);

  // Here we get the general information at the bottom of each specsheet and set the data
  useEffect(() => {
    async function getData() {
      try {
        const { data } = await axios.get(`${apiUrl}/api/specsheets/general2`);
        setImportantNotes(data[0].importantNotes);
        setNotes(data[0].importantNotes.general);
        setHelpfulLinks(data[0].helpfullLinks);
      } catch (e) {
        console.error(e);
      }
    }
    getData();
  }, []);

  return (
    <div>
      <section className={styles.notes}>
        <h2>{importantNotes.title}</h2>
        <ul>
          {notes.map((note, index) => <li key={`${note.item || note}-${index}`}>
            {note.item || note}
            {note.link && <> <a href={note.link}>{note.linkText}</a></>}
            {note.email && <> <a href={`mailto:${note.email}`}>{note.email}</a></>}
          </li>)}
        </ul>
      </section>
      <section className={styles.usefulLinks}>
        <h2>Useful links and contact details</h2>
        <div>
          {links.map((usefulLink, index) => {
            return (
              <div key={`link-${index}`} className={styles.linkContainer}>
                <a href={usefulLink.link} target="_blank" rel="noreferrer"><Icon name="file-type-doc" className={styles.linkIcon} />{usefulLink.title}</a>
              </div>
            );
          })}
        </div>
        <div>
          {emails.map((usefulLink, index) => {
            return (
              <div key={`email-${index}`} className={styles.linkContainer}>
                <a href={`mailto:${usefulLink.email}`} target="_blank" rel="noreferrer"><Icon name="mail" className={styles.linkIcon} />{usefulLink.title}</a>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default GeneralInformation2;
